import React, {
  useState,
  useCallback,
  useEffect
} from 'react';
import { Button } from 'devextreme-react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import devices from 'devextreme/core/devices';
import { formatMessage } from 'devextreme/localization';
import { BrowserMultiFormatReader } from '@zxing/library';
// import QrReader from 'react-qr-scanner';
import PopupMVP from '../PopupMVP';
import style from './popupqrcode.module.scss';

let onSendQR = false;

const PopupQRCode = ({
  filterDataGrid,
  visible,
  onClose,
  stockReducer: { selectPlantId },
  qrReducer: {
    listData,
    loading,
    storageData
  },
  qrData,
  qrDataClear,
  qrDataUpdateStorage,
  qrDataList
}) => {
  const [codeReader] = useState(new BrowserMultiFormatReader());
  const [videoInputDevices, setVideoInputDevices] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [modalVisible, setModalVisible] = useState(visible);
  // eslint-disable-next-line no-unused-vars
  // const [camera, setCamera] = useState(undefined);
  // eslint-disable-next-line no-unused-vars
  // const [qrError, setQrError] = useState(undefined);
  const [tQrData, setTQRData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  // const [stopScan, setStopScan] = useState(false);
  // const refQRReader = useRef(null);
  const [sendQR, setSendQR] = useState(false);

  /** Главная функция получения данных из кода */
  const functionsCode = useCallback((i) => {
    codeReader
      .decodeOnceFromVideoDevice(videoInputDevices[i].deviceId, 'video')
      .then((result) => {
        if (result.format === 11) {
          // Если формат соответствует qr-code, то надо извлечь информацию
          const resultDop = result.text.replace(/ /g, '').match(/(ИДН:|S\/N:)\d+/g);
          setTQRData(resultDop && resultDop[0] ? resultDop[0].replace(/(ИДН:|S\/N:)/g, '') : null);
        } else {
          setTQRData(result.text);
        }
        setSendQR(true);
        functionsCode(i);
      })
      .catch((err) => console.error(err));
  }, [setTQRData, setSendQR, videoInputDevices, codeReader]);

  useEffect(() => {
    if (visible) {
      // window.addEventListener('load', () => {
      codeReader
        .listVideoInputDevices()
        .then((videoInput) => {
          setVideoInputDevices(videoInput);
          videoInput.forEach((device) => console.log(`${device.label}, ${device.deviceId}`));
        })
        .catch((err) => console.error(err));
      // });
    }
  }, [codeReader, setVideoInputDevices, visible]);

  useEffect(() => {
    if (videoInputDevices && videoInputDevices.length > 1) {
      setSelectedDevice(1);
    } if (videoInputDevices && videoInputDevices.length === 1) {
      setSelectedDevice(0);
    }
  }, [videoInputDevices, codeReader, functionsCode]);

  useEffect(() => {
    if (selectedDevice !== null) {
      functionsCode(selectedDevice);
    }
  }, [functionsCode, selectedDevice]);

  // useEffect(() => {
  //   if (visible) {
  //     navigator.mediaDevices.enumerateDevices()
  //       .then((devices) => {
  //         console.log('devices', devices);
  //         const videoDevices = devices.filter((e) => e.kind === 'videoinput');
  //         if (videoDevices.length > 1) {
  //           setCamera(videoDevices[1].deviceId);
  //         }
  //       });
  //   }
  // }, [visible]);

  useEffect(() => {
    setModalVisible(visible);
  }, [visible]);

  /** Отправка запроса в сервис */
  useEffect(() => {
    if (sendQR) {
      if (tQrData) {
        qrData({
          barcodes: tQrData,
          plantId: selectPlantId
        });
        setSendQR(false);
        onSendQR = true;
      } else {
        notify(
          {
            message: formatMessage('textNoData'),
            height: 64,
            width: 354,
            position: {
              at: 'center center',
              my: 'bottom center',
              offset: '0 48'
            }
          },
          'warning',
          2000
        );
        setSendQR(false);
      }
    }
  }, [tQrData, sendQR, qrData, selectPlantId]);

  useEffect(() => {
    if (visible && listData.length > 0) {
      onSendQR = false;

      const temp = storageData.slice();
      let prover = true;
      // eslint-disable-next-line no-return-assign
      temp.map((item) => (item.qcId === listData[0].qcId ? prover = false : prover));
      if (prover) {
        notify(
          {
            message: formatMessage('textSuccess'),
            height: 64,
            width: 354,
            position: { at: 'center center', my: 'bottom center', offset: '0 48' }
          },
          'success',
          2000
        );
        temp.push(listData[0]);
        qrDataUpdateStorage(temp);
      } else {
        notify(
          {
            message: formatMessage('textAlreadyFound'),
            height: 64,
            width: 354,
            position: { at: 'center center', my: 'bottom center', offset: '0 48' }
          },
          'success',
          2000
        );
      }
      qrDataClear();
    } else if (visible && onSendQR) {
      onSendQR = false;
      notify(
        {
          message: formatMessage('textNoData'),
          height: 64,
          width: 354,
          position: {
            at: 'center center',
            my: 'bottom center',
            offset: '0 48'
          }
        },
        'warning',
        2000
      );
    }
  }, [visible, listData, qrDataUpdateStorage, storageData, qrDataClear]);

  // const handleError = (err) => {
  //   setQrError(err.message);
  // };

  // /** Если отсканировало и есть результат, то попадает сюда */
  // const handleScan = (data) => {
  //   if (data) {
  //     setTQRData(data);
  //     setStopScan(true);
  //     setSendQR(true);
  //   }
  // };

  // const onLoad = () => {
  // };

  // Загрузка данных из файла
  // const openImageDialog = useCallback(() => {
  //   refQRReader.current.openImageDialog();
  // }, [refQRReader]);

  const modalOnHiding = useCallback(() => {
    setModalVisible(false);
    onClose(false);
    qrDataList(filterDataGrid);
    codeReader.reset();
    setTQRData(null);
  }, [onClose, qrDataList, filterDataGrid, codeReader]);

  /** Работа с мобильной версией модальки */
  const isMobileDevice = !(devices.current().deviceType === 'desktop');
  const [heightModal, setHeightModal] = useState(!isMobileDevice ? 400 : window.innerHeight - 249);
  useEffect(() => {
    window.addEventListener('resize', () => (setHeightModal(!isMobileDevice ? 400 : window.innerHeight - 249)));
  }, [isMobileDevice, setHeightModal]);

  const onClickCamToggle = useCallback(() => {
    if (selectedDevice === 1) {
      setSelectedDevice(0);
    } else {
      setSelectedDevice(1);
    }
  }, [selectedDevice]);

  return (
    <PopupMVP visible={modalVisible}
              title={formatMessage('textModal').textQRCode}
              onHiding={modalOnHiding}
              width="600px"
              fullScreen={isMobileDevice}
    >
      <LoadPanel shadingColor={'rgba(255,255,255,0.8)'}
                 position={{ of: '#root' }}
                 showIndicator
                 shading
                 showPane
                 closeOnOutsideClick={false}
                 visible={loading}
      />
      <div className="formData">
        <div className={style.containers}>
          <div className={style.qrcode}>
            <div>
              {isMobileDevice && (
              <Button className={style.buttonSwap}
               width={70}
               height={70}
               type="default"
               icon="refresh"
               onClick={onClickCamToggle} />
              )}
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
              id="video"
              width="100%"
              height={heightModal}
            />
            </div>

            {/* <QrReader */}
            {/*   ref={refQRReader} */}
            {/*   delay={2000} */}
            {/*   onError={handleError} */}
            {/*   onScan={handleScan} */}
            {/*   onLoad={onLoad} */}
            {/*   style={{ width: '100%', maxHeight: '500px' }} */}
            {/*   legacyMode={!modalVisible} */}
            {/*   facingMode={'environment'} */}
            {/*   chooseDeviceId={() => camera} */}
            {/* /> */}

            <div className={style.buttonSearch}>
              <div className="text-center">{formatMessage('textModal').textQRCodeCamera}</div>
              <span>QRCode</span>
              <TextBox placeholder={formatMessage('textError').enterQRCode}
                       value={tQrData}
                       onValueChanged={({ value }) => setTQRData(value)}
                       stylingMode="outlined"
                       valueChangeEvent="input"
              >
                <TextBoxButton name="search"
                               location="after"
                               options={{
                                 icon: 'search',
                                 type: 'normal',
                                 stylingMode: 'text',
                                 onClick: () => {
                                   setSendQR(true);
                                 }
                               }}
                />
              </TextBox>
            </div>
          </div>
          {/* <div className={style.table}> */}
          {/*   <DataGrid dataSource={storageData} */}
          {/*             columnAutoWidth */}
          {/*             allowColumnReordering */}
          {/*             allowColumnResizing */}
          {/*             rowAlternationEnabled */}
          {/*   > */}
          {/*     <Selection */}
          {/*       mode={'multiple'} */}
          {/*       selectAllMode={'allPages'} */}
          {/*       showCheckBoxesMode={'always'} */}
          {/*     /> */}
          {/*     <Column dataField={'qcId'} */}
          {/*             caption={'№ СК'} */}
          {/*             allowSearch={false} */}
          {/*             allowFiltering={false} */}
          {/*     /> */}
          {/*     <Column dataField={'cgId'} */}
          {/*             caption={'№ партии'} */}
          {/*             allowSearch={false} */}
          {/*             allowFiltering={false} */}
          {/*     /> */}
          {/*     <Column dataField={'actualPieceId'} */}
          {/*             caption={'№ УЕ'} */}
          {/*             allowSearch={false} */}
          {/*             allowFiltering={false} */}
          {/*     /> */}
          {/*     <Column dataField={'weightNetto'} */}
          {/*             caption={'Вес нетто, т'} */}
          {/*             allowSearch={false} */}
          {/*             allowFiltering={false} */}
          {/*     /> */}
          {/*     <Column dataField={'weightBrutto'} */}
          {/*             caption={'Вес брутто, т'} */}
          {/*             allowSearch={false} */}
          {/*             allowFiltering={false} */}
          {/*     /> */}
          {/*   </DataGrid> */}
          {/* </div> */}
        </div>
        <div className="formButton">
          <Button text={formatMessage('textButton').close}
                  type="default"
                  stylingMode="text"
                  onClick={modalOnHiding}
          />
          {/* <Button type={'default'} */}
          {/*         stylingMode={'contained'} */}
          {/*         useSubmitBehavior */}
          {/*         width={200} */}
          {/* > */}
          {/*   <LoadIndicator className={'indicator'} visible={false} /> */}
          {/*   <span>Подтвердить</span> */}
          {/* </Button> */}
        </div>
      </div>
    </PopupMVP>
  );
};

export default PopupQRCode;
